import React, { useState, useEffect, useRef } from 'react';

import Button from 'CommonComponents/Button';
import CheckboxInput from 'CommonComponents/CheckboxInput';
import TableSearchInput from 'CommonComponents/TableSearchInput';

function PermissionsTable(props) {
    const [permissionsData, setPermissionsData] = useState({});
    const [request, setRequest] = useState(false);
    const [search, setSearch] = useState('');

    const fetchPermissions = (searchStr = '') => {
        setRequest(true);
        const url = searchStr ? `/admin/permissions?search=${searchStr}` : '/admin/permissions';

        axios
            .get(url)
            .then((res) => {
                setRequest(false);
                const { permissions } = res.data;

                const result = {};
                const rowData = {};
                props.roles.forEach((role) => {
                    rowData[role.name] = 0;
                });

                permissions.forEach((row) => {
                    Object.keys(row).forEach((permissionName) => {
                        result[permissionName] = { ...rowData };
                        row[permissionName].forEach((item) => {
                            result[permissionName][item] = 1;
                        });
                    });
                });
                setPermissionsData(result);
            })
            .catch((error) => {
                setRequest(false);
                console.log(error);
            });
    };

    const permissionChange = (roleName, permissionName, val) => {
        const data = JSON.parse(JSON.stringify(permissionsData));
        data[permissionName][roleName] = val ? 1 : 0;
        setPermissionsData(data);
    };

    const debounceSearch = useRef(
        _.debounce((search) => {
            fetchPermissions(search);
        }, 500),
    );

    const searchChange = (e) => {
        const val = e.target.value;
        setSearch(val);
    };

    const save = () => {
        setRequest(true);
        const requestData = {};

        Object.keys(permissionsData).forEach((permissionName) => {
            requestData[permissionName] = [];
            Object.keys(permissionsData[permissionName]).forEach((roleName) => {
                if (permissionsData[permissionName][roleName]) {
                    requestData[permissionName].push(roleName);
                }
            });
        });

        const data = {
            permissions: requestData,
        };

        axios
            .put('/admin/permissions', data)
            .then((response) => {
                fetchPermissions(search);
            })
            .catch((e) => {
                setRequest(false);
                console.log(e);
            });
    };

    useEffect(() => {
        debounceSearch.current(search);
    }, [search]);

    return (
        <div className="table__card">
            {request && (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )}
            <div className="tw-flex tw-items-end tw-justify-between tw-mb-6">
                <div>
                    <h5 className="table__header">Roles and Permissions</h5>
                </div>
                <div className="tw-flex tw-gap-x-1.5">
                    <TableSearchInput searchValue={search} placeholder="Search permission by name" handleChange={searchChange} />
                    <Button variant="primary" onClick={save} disabled={request}>
                        {$t('Save')}
                    </Button>
                </div>
            </div>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-min-w-48 tw-sticky tw-left-0 tw-h-fit">Permission</th>
                            {props.roles.map((role) => {
                                return (
                                    <th className="tw-min-w-40" key={role.id}>
                                        {role.name}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(permissionsData).map((permName) => {
                            return (
                                <tr key={permName}>
                                    <td className="!tw-bg-white tw-font-semibold tw-text-nowrap tw-sticky tw-left-0 tw-h-fit">{permName}</td>
                                    {Object.keys(permissionsData[permName]).map((roleName) => {
                                        return (
                                            <td key={permName + roleName}>
                                                <CheckboxInput
                                                    defaultChecked={permissionsData[permName][roleName]}
                                                    label={permissionsData[permName][roleName] ? 'Yes' : 'No'}
                                                    onChange={() => permissionChange(roleName, permName, !permissionsData[permName][roleName])}
                                                    disabled={roleName == 'Super-admin'}
                                                />
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default PermissionsTable;
